import React from "react";

import ctl from "@netlify/classnames-template-literals";
import { Button, Text } from "components";

export default function DemoInfo() {
  return (
    <>
      <div className={demoInfoWrapStyle}>
        <Text
          value="We provide the complete platform for your financial and banking services. "
          variant="h2"
          className={textStyle}
        />
        <Button text="Get in touch" size="small" to="/get-demo" hasArrow />
      </div>
      <hr />
    </>
  );
}

const textStyle = ctl(`
md:mb-[36px]
mb-[24px]
`);

const demoInfoWrapStyle = ctl(`
md:pt-[145px]
pt-[82px]
md:pb-[82px]
pb-[60px]
text-center
`);
